module.exports = __webpack_public_path__ + "static/media/2-en.bb7b654e.svg";